import { xhrPath } from '@/xhr/connections.js';
import picador from '@/xhr/connections/picador';

export default {
  async createOrganization(name) {
    return await picador.post('createOrganization', xhrPath.organization, { name });
  },

  async getUserOrganizations(page, resultsPerPage, sort, sortDirection, filterString) {
    const params = { page, resultsPerPage, sort, sortDirection, filterString };
    return await picador.get('getUserOrganizations', `${xhrPath.organization}/me`, { params });
  },

  async getUserOrganizationNames() {
    return await picador.get('getUserOrganizationNames', `${xhrPath.organization}/me/names`);
  },

  async getOrganizationDetails(id) {
    return await picador.get('getOrganizationDetails', `${xhrPath.organization}/${id}`);
  },

  async getOrganizationMembers(id, page, resultsPerPage, sort, sortDirection, filterString) {
    const params = { page, resultsPerPage, sort, sortDirection, filterString };
    return await picador.get('getOrganizationMembers', `${xhrPath.organization}/${id}/members`, {
      params,
    });
  },

  async getAllOrganizationMembers(id) {
    return await picador.get(
      'getAllOrganizationMembers',
      `${xhrPath.organization}/${id}/all-members`
    );
  },

  async getOrganizationTeams(id, page, resultsPerPage, sort, sortDirection, filterString) {
    const params = { page, resultsPerPage, sort, sortDirection, filterString };
    return await picador.get('getOrganizationTeams', `${xhrPath.organization}/${id}/teams`, {
      params,
    });
  },

  async getAllOrganizationTeams(id) {
    return await picador.get('getAllOrganizationTeams', `${xhrPath.organization}/${id}/all-teams`);
  },

  async inviteOrganizationMembers(id, invitees) {
    return await picador.post('inviteOrganizationMembers', `${xhrPath.organization}/${id}/invite`, {
      invitees,
    });
  },

  async getOrganizationTeamDetails(id, teamID) {
    return await picador.get(
      'getOrganizationTeamDetails',
      `${xhrPath.organization}/${id}/team/${teamID}`
    );
  },

  async addOrganizationTeam(id, team) {
    return await picador.post('addOrganizationTeam', `${xhrPath.organization}/${id}/team/create`, {
      team,
    });
  },

  async removeOrganizationTeams(id, teamIds) {
    return await picador.delete(
      'removeOrganizationTeams',
      `${xhrPath.organization}/${id}/team/${teamIds.join(',')}`
    );
  },

  async updateOrganizationTeam(id, team) {
    return await picador.patch('updateOrganizationTeam', `${xhrPath.organization}/${id}/team`, {
      team,
    });
  },

  async removeOrganizationMembers(id, memberIds) {
    return await picador.delete(
      'removeOrganizationMembers',
      `${xhrPath.organization}/${id}/members/${memberIds.join(',')}`
    );
  },

  async updateOrganizationMember(id, updatedMember) {
    return await picador.patch('updateOrganizationMember', `${xhrPath.organization}/${id}/status`, {
      id: updatedMember._id,
      role: updatedMember.role,
    });
  },
};
